<template>
  <div>
    <b-container fluid class="moow-footer">
      <img :src="moowLogo" class="footer-logo-holder"/>
      <md-divider class="moow-divider fat"></md-divider>
      <b-row>
        <b-col>
          <p class="footer-nav-item">EDMI Group OÜ  •  Pärnu mnt 148, Tallinn  •  moowle@moowle.com  •  +372 5366 6903</p>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col>
          <p><router-link to="market" class="footer-nav-item">Marketplace</router-link></p>
          <p><router-link to="landlord" class="footer-nav-item">Landlord</router-link></p>
          <!-- <p><router-link to="tenant">Tenant</router-link></p> -->
          <p><router-link to="login" class="footer-nav-item">Login</router-link></p>
          <p><router-link to="register" class="footer-nav-item">Sign up</router-link></p>
        </b-col>
        <b-col>
          <p><a class="footer-nav-item" href="https://medium.com/civil-bits" target="_blank">Blog</a></p>
          <p class="footer-nav-item" @click="showTerms=true">Terms & Conditions</p>
          <p class="footer-nav-item" @click="showContactForm=true">Talk to Sales</p>
          <p class="footer-nav-item" @click="showContactForm=true">Request a demo</p>
          <p><a class="footer-nav-item" href="https://moowle.com/contact/" target="_blank">Contact</a></p>
          <md-dialog :md-active.sync="showTerms">
            <terms-conditions
              :hideActions="true">
            </terms-conditions>
          </md-dialog>
        </b-col>
      </b-row>


    </b-container>

    <md-dialog :md-active.sync="showContactForm">
      <contact-form
        @closeForm="closeContactUsForm">
      </contact-form>
    </md-dialog>



    <md-snackbar :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
    </md-snackbar>

  </div>
</template>

<script>

import ContactUsForm from '../dialogs/ContactUsForm'
import TermsAndConditions from '../../components/dialogs/TermsAndConditions'

export default {
  name: "landlord",
  components: {
    'contact-form':ContactUsForm,
    'terms-conditions': TermsAndConditions

  },
  validator: null,
  data() {
    return {
      showTerms: false,
      showSnackbar:false,
      snackbarMessage: "",
      showContactForm: false,
    };
  },
  computed: {
    moowLogo(){
      return require('../../assets/logos/moowle-logo-white.png')
    },
    listIcon(){
      return require('../../assets/icons/list_blue.svg')
    },
    connectIcon(){
      return require('../../assets/icons/connect_blue.svg')
    },
    peaceIcon(){
      return require('../../assets/icons/peace_blue.svg')
    },
    interImg(){
      return require('../../assets/images/interior_l1.jpg')

    },
    filterButtonText(){
      if(this.filterHasInput()) return "Find"
      else return "Scroll down"
    },
  },
  created() {

  },
  mounted() {

  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    openContactUsForm(){
      this.showContactForm=true
    },
    closeContactUsForm(isSuccess){
      this.showContactForm=false
      if(isSuccess) this.notifyUser("Thank You. We will be in touch promptly")
      else this.notifyUser("Something is not right, contact support@moowle.com")
    },
    notifyUser(msg){
      this.snackbarMessage = msg
      this.showSnackbar =  true
    }
  }
};
</script>

<style scoped>
@import "../../assets/styles/global.css";
@import "../../assets/styles/listings-view.css";
@import "../../assets/styles/portal.css";

</style>


// WEBPACK FOOTER //
// src/components/footer/Footer.vue